import { useMutation } from '@tanstack/react-query'

import type { DepositLookupRequest, DepositLookupResponse } from '../../types/deposit.js'

import { apiClient } from '../../lib/client.js'

export const useLookupBookingForDepositMutation = () => {
  return useMutation({
    mutationFn: async (data: DepositLookupRequest) => {
      const response = await apiClient.client.post<DepositLookupResponse>(
        '/payment/lookup-booking',
        data
      )
      return response.data
    },
  })
}
